import NextBtn from "../common/NextBtn";
import PreviousBtn from "../common/PreviousBtn";
import styles from "./CreateMapSetting.module.css";
import Map from "./Map";
import PreViewMapType from "./PreViewMapType";
import { Dispatch, SetStateAction } from "react";
import ContentTitle from "../common/ContentTitle";

interface MapSettingProps {
    processIdx: number;
    progressProcess: (n: number) => void;
    mapType: string;
    setMapType: Dispatch<SetStateAction<string>>;
}

/**
 * @author cjs
 * @date 2024-09-27 10:24:39
 * @remark 지도만들기 지도 종류 설정 컴포넌트
 * @pram props
 * @props MapSettingProps
        processIdx(required) : 지도만들기 화면 순서
        progressProcess(required) : 지도만들기 화면 순서 변경 함수
        mapType(required) : 지도 설정 데이터
        setMapType(required) : 지도 설정 데이터 변경 함수
    @returns MapSetting
 */

function MapSetting(props: MapSettingProps) {
    return (
        <>
            <div className={styles.wrapPreView}>
                <PreViewMapType mapType={props.mapType} />
            </div>
            <div className={`${styles.wrap} undraggable`}>
                <div className={styles.container}>
                    <div className={styles.title}>
                        <ContentTitle title="배경지도선택" />
                    </div>
                    {<Map mapType={props.mapType} setMapType={props.setMapType} />}
                    <div className={styles.footer}>
                        <div className={styles.wrapProgressBtn}>
                            <div className={`${props.processIdx === 0 ? styles.hideBtn : styles.activeBtn}`}>
                                <PreviousBtn progressProcess={props.progressProcess} />
                            </div>
                            <div className={styles.nextBtn}>
                                <NextBtn progressProcess={props.progressProcess} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MapSetting;
